export enum Area {
    mm2 = 0.000001,
    cm2 = 0.0001,
    m2 = 1,
    km2 = 1000000,
    acres = 4046.86,
    hectares = 10000,
}